import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Button } from 'src/components/Buttons/Button';
import { useDrawer } from 'src/hooks/useDrawer';
import { useModalContext } from 'src/hooks/useModalContext';
import { cioTrackEvent } from 'src/modules/cio';
import { useRoute } from 'src/router/hooks/useRoute';

export const AuthorizedButtons = () => {
  const { t } = useTranslation();

  const { openModal } = useModalContext();
  const { closeDrawer } = useDrawer();
  const { ROUTE } = useRoute();

  const navigate = useNavigate();

  return (
    <>
      <Button
        mode="button-primary"
        onClick={() => {
          cioTrackEvent('deposit_btn_click', 'sidebar');
          openModal('DEPOSIT');
          closeDrawer();
        }}
        title={`${t('general.deposit')}`}>
        {t('general.deposit')}
      </Button>
      <Button
        title={`${t('general.account')}`}
        mode="button-secondary"
        onClick={() => {
          navigate(ROUTE.ACCOUNT_PROFILE_MAIN.get());
          closeDrawer();
        }}>
        {t('general.account')}
      </Button>
    </>
  );
};
